import { Effect, Layer } from 'effect';
import { ConfigurationTemplatesAuthoringService } from './authoringService';
import { makePutTemplateResolver, PutTemplate } from './gavelAuthoringService/put';
import { GavelConfig } from '../../../services/gavelConfig';
import { TokenProviderService } from '../../../services/tokenProvider';
import { AxiosHttpService, HttpService } from '../../../services/http';
import { CreateTemplate, makeCreateTemplateResolver } from './gavelAuthoringService/create';
const makeGavelConfigurationTemplatesAuthoringService = Effect.gen(function* () {
    const config = yield* GavelConfig;
    const tokenService = yield* TokenProviderService;
    const http = yield* HttpService;
    const put = (tenantId, templateId, template) => tokenService.getToken().pipe(Effect.flatMap(token => Effect.request(new PutTemplate({
        baseUrl: config.gavelUrl,
        template,
        templateId,
        tenantId,
        token: `Bearer ${token}`,
    }), makePutTemplateResolver(http))));
    const create = (tenantId, template) => tokenService.getToken().pipe(Effect.andThen(token => Effect.request(new CreateTemplate({
        baseUrl: config.gavelUrl,
        template,
        tenantId,
        token: `Bearer ${token}`,
    }), makeCreateTemplateResolver(http))));
    return { put, create };
});
export const BaseGavelConfigurationTemplatesAuthoringService = Layer.effect(ConfigurationTemplatesAuthoringService, makeGavelConfigurationTemplatesAuthoringService);
export const DefaultGavelConfigurationTemplatesAuthoringService = BaseGavelConfigurationTemplatesAuthoringService.pipe(Layer.provide(AxiosHttpService));
